import * as $ from 'jquery';
import 'bootstrap';

export class timaticColumnControl {
    initializeTimaticColumn() {       
        let rowCount: any = $('[data-timatic-row-count]').length > 0 ? parseInt($('[data-timatic-row-count]').attr('data-timatic-row-count')) : 4;
        let rowCountMobile: any = $('[data-timatic-row-count-mobile]').length > 0 ? parseInt($('[data-timatic-row-count-mobile]').attr('data-timatic-row-count-mobile')) : 2;
        let timaticColumnSection: any = $('#timatic-column-control .content--image .col-sm-4');
        let timaticColumnSectionMobile: any = $('#timatic-column-control .content--image .col-xs-6');
        $(timaticColumnSection).each(function (itemCount: any) {
            $(this).css({ 'width': 100 / rowCount + '%' });
        });
        if (window.innerWidth < 1024) {
            $(timaticColumnSectionMobile).each(function (itemCount: any) {
                $(this).css({ 'width': 100 / rowCountMobile + '%' });
            });
        }

    }
}

let scope: Element = document.querySelector('#timatic-column-control');
if (scope) {
    try {
        let timaticcolumn = new timaticColumnControl();
        timaticcolumn.initializeTimaticColumn();
    } catch (e) { console.error(e); }
}